import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-date-slider',
    templateUrl: './date-slider.component.html',
    styleUrls: ['./date-slider.component.scss']
})
export class DateSliderComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild("rightTooltip", { static: true }) rightTooltip: ElementRef<HTMLElement>;
    @ViewChild("leftTooltip", { static: true }) leftTooltip: ElementRef<HTMLElement>;
    @Input() leftTooltipTpl?: TemplateRef<any>;
    @Input() rightTooltipTpl?: TemplateRef<any>;
    @Input() tooltipWidth: number = 90;
    isMousedown: boolean = false;
    mousedownCancler: any;
    mouseupCancler: any;
    targetName: string = "";
    outsideResetPositionTargetName = "";
    dragTarget?: HTMLElement;
    dragStartX?: number;
    dragStartPosition: number = 0;

    @Input() leftBtnPosition: number = 0;
    @Input() rightBtnPosition: number = 100;

    tempPosition?: number;

    tooltipOffset: number = 0;

    tooltipGap = 12;
    // The gap of the two sliding round buttons
    gap: number = 50;
    arrowGap: number = 12;
    // This padding area used to draw the arrow when the button at the letf or right end points.
    arrowPadding = 30;
    @Output() onLeftMove: EventEmitter<{ leftPercentage: number, rightPercentage: number, buttonDistance: number }> = new EventEmitter();
    @Output() onRightMove: EventEmitter<{ leftPercentage: number, rightPercentage: number, buttonDistance: number }> = new EventEmitter();
    @Output() onChange: EventEmitter<{ leftPercentage: number, rightPercentage: number, buttonDistance: number, targetName: string }> = new EventEmitter();

    constructor(private ngZone: NgZone, private renderer2: Renderer2, private el: ElementRef) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['leftBtnPosition']) {
            this.outsideResetPositionTargetName = 'left';
            this.recalculatePosition(false);
            this.outsideResetPositionTargetName = '';
        } else if (changes['rightBtnPosition']) {
            this.outsideResetPositionTargetName = 'right';
            this.recalculatePosition(false);
            this.outsideResetPositionTargetName = '';
        }
    }
    ngOnDestroy(): void {
        if (this.mousedownCancler) {
            this.mousedownCancler();
        }
    }

    ngOnInit(): void {
        this.ngZone.runOutsideAngular(() => {
            this.mousedownCancler = this.renderer2.listen("document", "mousemove", (e: MouseEvent) => {
                if (this.isMousedown) {
                    this.mousemoveHandler(e);
                }
            });
            this.mouseupCancler = this.renderer2.listen("document", "mouseup", () => {
                this.isMousedown = false;

                if (this.tempPosition != undefined && this.tempPosition != null) {
                    if (this.targetName === "left") {
                        this.leftBtnPosition = this.tempPosition;
                    } else {
                        this.rightBtnPosition = this.tempPosition;
                    }
                }
                this.tempPosition = undefined;
                this.targetName = "";
                this.dragStartPosition = 0;
            })
        });

        //this.checkTooltipDistance((this.rightBtnPosition - this.leftBtnPosition) * totalDistance / 100, totalDistance);

        setTimeout(() => {
            this.outsideResetPositionTargetName = 'all';
            this.recalculatePosition();
            this.outsideResetPositionTargetName = '';
        }, 100);
    }

    recalculatePosition(isEmitChangeEvent = true) {
        const totalDistance = this._getContainerWidth();
        const buttonDistance = (this.rightBtnPosition - this.leftBtnPosition) * totalDistance / 100;
        this.checkTooltipDistance(buttonDistance + (this.gap - this.tooltipGap), totalDistance);
        if (isEmitChangeEvent) {
            this.onChange.emit({
                leftPercentage: this.leftBtnPosition,
                rightPercentage: this.rightBtnPosition,
                buttonDistance,
                targetName: this.targetName
            });
        }
    }

    _getContainerWidth() {
        // NOTE:At the end and start of the slider container has two paddings. so we need to minus these paddings.
        // the left padding is 12(the sliding round button's height), and the right padding equal the gap
        return (this.el.nativeElement as HTMLElement).getBoundingClientRect().width - this.gap - 12;
    }

    mousedownHandler(e: MouseEvent) {
        this.dragTarget = ((e.srcElement || e.target) as HTMLElement).parentElement;
        if (this.dragTarget.classList.contains("a-date-r-s-start")) {
            this.targetName = "left";
        } else if (this.dragTarget.classList.contains("a-date-r-s-end")) {
            this.targetName = "right";
        }
        this.dragStartPosition = parseFloat(this.dragTarget.style.width.slice(0, this.dragTarget.style.width.length - 1));
        this.dragStartX = e.x;
        this.isMousedown = true;
    }

    mousemoveHandler(e: MouseEvent) {
        const totalDistance = this._getContainerWidth();

        const moveDistance = e.x - this.dragStartX!;
        const tempPosition = this.dragStartPosition + moveDistance / totalDistance * 100;
        if (this.targetName === "left") {
            if (tempPosition <= this.rightBtnPosition && tempPosition >= 0) {
                this.dragTarget!.style.width = tempPosition + "%";
                this.tempPosition = tempPosition;
            } else {
                if (moveDistance > 0) {
                    this.dragTarget!.style.width = this.rightBtnPosition + "%";
                    this.tempPosition = this.rightBtnPosition;
                } else {
                    this.dragTarget!.style.width = 0 + "%";
                    this.tempPosition = 0;
                }
            }
            const buttonDistance = (this.rightBtnPosition - this.tempPosition) * totalDistance / 100;
            this.checkTooltipDistance(buttonDistance + (this.gap - this.tooltipGap), totalDistance);
            this.onLeftMove.emit({
                leftPercentage: this.tempPosition,
                rightPercentage: this.rightBtnPosition,
                buttonDistance
            });
            this.onChange.emit({
                leftPercentage: this.tempPosition,
                rightPercentage: this.rightBtnPosition,
                buttonDistance,
                targetName: this.targetName
            });
        } else {
            if (tempPosition >= this.leftBtnPosition && tempPosition <= 100) {
                this.dragTarget!.style.width = tempPosition + "%";
                this.tempPosition = tempPosition;
            } else {
                if (moveDistance > 0) {
                    this.dragTarget!.style.width = "100%";
                    this.tempPosition = 100;
                } else {
                    this.dragTarget!.style.width = this.leftBtnPosition + "%";
                    this.tempPosition = this.leftBtnPosition;
                }
            }
            const buttonDistance = (this.tempPosition - this.leftBtnPosition) * totalDistance / 100;
            this.checkTooltipDistance(buttonDistance + (this.gap - this.tooltipGap), totalDistance);
            this.onRightMove.emit({
                leftPercentage: this.leftBtnPosition,
                rightPercentage: this.tempPosition,
                buttonDistance
            });
            this.onChange.emit({
                leftPercentage: this.leftBtnPosition,
                rightPercentage: this.tempPosition,
                buttonDistance,
                targetName: this.targetName
            });
        }

    }
    checkTooltipDistance(btnDistance: number, totalDistance: number) {
        let leftTooltipWidth = this.tooltipWidth, leftW = leftTooltipWidth / 2,
            rightTooltipWidth = this.tooltipWidth, rightW = rightTooltipWidth / 2;
        let distance = leftW + rightW;
        this._checkLeftArrowPosition(this.leftTooltip.nativeElement, (this.leftTooltip.nativeElement.children[0] as HTMLElement), btnDistance, distance, leftTooltipWidth, totalDistance);
        this._checkRightArrowPosition(this.rightTooltip.nativeElement, (this.rightTooltip.nativeElement.children[0] as HTMLElement), btnDistance, distance, rightTooltipWidth, totalDistance)
    }

    _checkLeftArrowPosition(leftBtnEl: HTMLElement, leftArrowEl: HTMLElement, btnDistance: number, tooltipTouchDistance: number, tooltipWidth: number, totalDistance: number) {
        let maxOffsetDistance = (tooltipWidth - this.tooltipGap) / 2, position = (this.targetName === "left" ? this.tempPosition : this.leftBtnPosition) / 100 * totalDistance, positionWithGap = position + this.gap;
        if (Number.isNaN(position)) {
            return;
        }
        // NOTE:this.targetName === "" this condition is used to initialize the button's position.
        if (position < maxOffsetDistance) {//at left end
            let tooltopOffset = maxOffsetDistance - position;
            let arrowOffset = tooltopOffset;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance - this.arrowGap / 2) {
                arrowOffset = maxOffsetDistance - this.arrowGap / 2;
            }
            if (tooltopOffset < 0) {
                tooltopOffset = 0;
            }
            let arrowPosition = this.tooltipGap / 2 - position;
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            leftBtnEl.style.setProperty("--arrow-point", `calc(7.5px - ${arrowPosition}px) 15px`);
            leftBtnEl.style.setProperty("--right-point", `calc(100% - ${this.arrowPadding}px) 0%`);
            leftBtnEl.style.transform = `translateX(calc(50% + ${tooltopOffset + "px"}))`;
            leftArrowEl.style.transform = `translateX(calc(7.5px - ${arrowOffset + "px"}))`;

        } else if ((totalDistance - position) + this.gap < (maxOffsetDistance + tooltipWidth)) {//at right end
            /* NOTE:The reason for minus the gap that is ensure the tootip has a correctly gap when the sliding round button also has the gap.
            Otherwise the tootip will have two gaps(tootip gap + the round button gap) when the two tooltips touch at the start position or the end position
            */
            let tooltopOffset = maxOffsetDistance + tooltipWidth - (totalDistance - position) - this.gap,
                arrowOffset = tooltopOffset;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance - this.arrowGap / 2) {
                arrowOffset = maxOffsetDistance - this.arrowGap / 2;
            }
            if (tooltopOffset < 0) {
                tooltopOffset = 0;
            }
            let arrowPosition = maxOffsetDistance - (totalDistance - position);//(maxOffsetDistance * 2) - btnDistance;
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            leftBtnEl.style.setProperty("--arrow-point", `calc(7.5px + ${arrowPosition}px) 15px`);
            leftBtnEl.style.setProperty("--right-point", `calc(100% - ${this.arrowPadding - arrowPosition / 3}px) 0%`);
            // This 5 is make sure that the left tooltip will be coveres the right tootip 5px.
            leftBtnEl.style.transform = `translateX(calc(50% - ${tooltopOffset - 5 + "px"}))`;
            leftArrowEl.style.transform = `translateX(calc(7.5px + ${arrowOffset - 5 + "px"}))`;
        } else if (tooltipTouchDistance > btnDistance) {//left and right tooltip touched
            let tooltopOffset = (tooltipTouchDistance - btnDistance) / 2 - this.tooltipGap / 2, arrowOffset = tooltopOffset - this.arrowGap / 2;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance) {
                arrowOffset = maxOffsetDistance;
            }
            if (tooltopOffset < 0) {
                tooltopOffset = 0
            }
            let arrowPosition = (maxOffsetDistance * 2) - btnDistance;
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            leftBtnEl.style.setProperty("--arrow-point", `calc(7.5px + ${arrowPosition / 2 - arrowOffset}px) 15px`);
            leftBtnEl.style.setProperty("--right-point", `calc(100% - ${this.arrowPadding}px) 0%`);
            leftArrowEl.style.transform = `translateX(calc(7.5px + ${arrowOffset + "px"}))`;
            leftBtnEl.style.transform = `translateX(calc(50% - ${tooltopOffset + "px"}))`;
        } else if (this.targetName === "left" || this.outsideResetPositionTargetName == 'left' || this.outsideResetPositionTargetName == 'all') {
            leftArrowEl.style.transform = ``;
            leftBtnEl.style.transform = ``;
            leftBtnEl.style.setProperty("--arrow-point", "7.5px 15px");
            leftBtnEl.style.setProperty("--right-point", `calc(100% - ${this.arrowPadding}px) 0%`);
        }
    }

    _checkRightArrowPosition(rightBtnEl: HTMLElement, rightArrowEl: HTMLElement, btnDistance: number, tooltipTouchDistance: number, tooltipWidth: number, totalDistance: number) {
        let maxOffsetDistance = (tooltipWidth - this.tooltipGap) / 2, position = (this.targetName === "right" ? this.tempPosition : this.rightBtnPosition) / 100 * totalDistance, positionWithGap = position + this.gap;
        if (Number.isNaN(position)) {
            return;
        }
        // NOTE:this.targetName === "" this condition is used to initialize the button's position.
        if (positionWithGap < (maxOffsetDistance + tooltipWidth)) {// at left end
            /* NOTE:The reason for minus the gap that is ensure the tootip has a correctly gap when the sliding round button also has the gap.
            Otherwise the tootip will have two gaps(tootip gap + the round button gap) when the two tooltips touch at the start position or the end position
            */
            let tooltopOffset = maxOffsetDistance + tooltipWidth - this.tooltipGap / 2 - positionWithGap;
            let arrowOffset = maxOffsetDistance + tooltipWidth - this.tooltipGap / 2 - positionWithGap;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance - this.arrowGap / 2) {
                arrowOffset = maxOffsetDistance - this.arrowGap / 2;
            }
            if (tooltopOffset < 0) {
                tooltopOffset = 0;
            }
            let arrowPosition = maxOffsetDistance - position;
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            rightBtnEl.style.setProperty("--arrow-point", `calc(7.5px + 30px - ${arrowPosition}px) 100%`);
            rightBtnEl.style.setProperty("--left-point", `${this.arrowPadding - arrowPosition / 3}px 0`);
            rightBtnEl.style.transform = `translateX(calc(50% + ${tooltopOffset + "px"}))`;
            rightArrowEl.style.transform = `translateX(calc(7.5px - ${arrowOffset + "px"}))`;
            //console.log("left", positionWithGap, maxOffsetDistance + tooltipWidth, totalDistance);
        } else if ((totalDistance - position) < maxOffsetDistance) {//at right end
            let tooltopOffset = maxOffsetDistance - (totalDistance - position);
            let arrowOffset = tooltopOffset;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance - this.arrowGap / 2) {
                arrowOffset = maxOffsetDistance - this.arrowGap / 2;
            }
            let arrowPosition = this.tooltipGap / 2 - (totalDistance - position);
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            rightBtnEl.style.setProperty("--arrow-point", `calc(7.5px + 30px + ${arrowPosition}px) 100%`);
            rightBtnEl.style.setProperty("--left-point", `${this.arrowPadding}px 0`);
            rightBtnEl.style.transform = `translateX(calc(50% - ${tooltopOffset + "px"}))`;
            rightArrowEl.style.transform = `translateX(calc(7.5px + ${arrowOffset + "px"}))`;
        } else if (tooltipTouchDistance > btnDistance) {//left and right tooltip touched
            let tooltopOffset = (tooltipTouchDistance - btnDistance) / 2 - this.tooltipGap / 2,
                arrowOffset = tooltopOffset - this.arrowGap / 2;
            if (arrowOffset < 0) {
                arrowOffset = 0;
            } else if (arrowOffset > maxOffsetDistance) {
                arrowOffset = maxOffsetDistance;
            }
            if (tooltopOffset < 0) {
                tooltopOffset = 0;
            }
            let arrowPosition = (maxOffsetDistance * 2) - btnDistance;
            if (arrowPosition < 0) {
                arrowPosition = 0;
            }
            //console.log("left and right tooltip touched")
            // leftBtnEl.style.setProperty("--arrow-point", `calc(7.5px + ${arrowPosition / 2 - arrowOffset}px) 15px`);
            rightBtnEl.style.setProperty("--arrow-point", `calc(7.5px + 30px - ${arrowPosition / 2 - arrowOffset}px) 100%`);
            rightBtnEl.style.setProperty("--left-point", `${this.arrowPadding}px 0`);
            rightBtnEl.style.transform = `translateX(calc(50% + ${tooltopOffset + "px"}))`;
            rightArrowEl.style.transform = `translateX(calc(7.5px - ${arrowOffset + "px"}))`;
        } else if (this.targetName === "right" || this.outsideResetPositionTargetName == 'right' || this.outsideResetPositionTargetName == 'all') {
            rightArrowEl.style.transform = ``;
            rightBtnEl.style.transform = ``;
            rightBtnEl.style.setProperty("--arrow-point", "calc(7.5px + 30px) 100%");
            rightBtnEl.style.setProperty("--left-point", `${this.arrowPadding}px 0`);
            //console.log("11111")
        }
    }
}
